import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { TimelineMax, TweenLite, Power3 } from "gsap";
import { FontWeight, FontStyle } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { IDimConfig, ResizeHelper } from"@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { Point, Text, Sprite, Texture, BLEND_MODES  } from "pixi.js";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { AnimationEffects } from "../../../effects/AnimationEffects";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";
import { TranslationConfig } from "../../../translations/TranslationConfig";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { PunkSymbolData } from "../../../punkEngine/config/PunkSymbolData";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";

export class XWayStateLevel extends StateHandler{

    public static LEVEL_1:number = 0;
    public static LEVEL_2:number = 1;
    public static LEVEL_3:number = 2;

    protected static ValueLvls:number[] = [800,2200,4600];
    protected static TextureLvls:string[] = ["Header_A","Header_B","Header_C"];
    protected static SpineLvls:string[] = ["Header_Loop_A","Header_Loop_B","Header_Loop_C"];

    public get lastLvl():number{
        return XWayStateLevel.ValueLvls[this.state-1] ? XWayStateLevel.ValueLvls[this.state-1] : 0;
    }

    public get nextLvl():number{
        return XWayStateLevel.ValueLvls[this.state+1] ? XWayStateLevel.ValueLvls[this.state+1] : 100000000000000;
    }

    public get valueLvl():number{
        return XWayStateLevel.ValueLvls[this.state]
    }

    public get TextureLvl():string{
        return XWayStateLevel.TextureLvls[this.state]
    }

    public get SpineLvl():string{
        return XWayStateLevel.SpineLvls[this.state]
    }

    public set(value:number):boolean{
        if(value > XWayStateLevel.LEVEL_3 || value < XWayStateLevel.LEVEL_1) return false;
        super.set(value);
        return true;
    }
}

export class TrainState {

    public static INTRO:string = "Train_Intro/Intro_";
    public static TRAVEL:string = "Train_Travel/Travel_";
    public static TRAVEL_GREEN:string = "Train_Travel_Green/Travel_";
    public static OPEN_CLOSE:string = "Train_Stop_Open/Stop_Open_";
    public static OUTRO:string = "Train_Outro/Outro_";

    private static iconLinks:Map<string,string> = new Map([
        ["X1" , "Dead/Dead_Spray"],
        ["X2" , "Train_Icons/x2"],
        ["X3" , "Train_Icons/x3"],
        ["X5" , "Train_Icons/x5"],
        ["X10" , "Train_Icons/x10"],
        ["X15" , "Train_Icons/x15"],
        ["X25" , "Train_Icons/x25"],
        ["WJ" , "Train_Icons/Jumping_Wild"],
        ["FULL" , "Train_Icons/6x6"],
        ["SPIN1" , "Train_Icons/Retrigger1"],
        ["SPIN2" , "Train_Icons/Retrigger2"],
        ["SPIN3" , "Train_Icons/Retrigger3"],
        ["MFS" , "Train_Icons/X_Ways"],
    ])

    public static CART_MODE:string = "";
    public static CART_LOOP:boolean = false;
    
    public static setCartMode(textures:Texture[] & undefined[]):void{
        this.CART_MODE = "";
        let leftSide:boolean = false;
        let rightSide:boolean = false;

        for(let t:number = 0; t < textures.length; t++){
            if(textures[t] == undefined ) continue;
            if(t <= 2) leftSide = true;
            else if(t > 2) rightSide = true;
        }
        if(rightSide){
            this.CART_MODE = leftSide ? "_LR" : "_R";
        }
    }

    public static getDuration(state:string):number{
        let time:number = 0;
        if(state == this.TRAVEL){
            state = this.CART_LOOP ? this.TRAVEL_GREEN : this.TRAVEL;
            time = MathHelper.frameToSeconds(GameResources.getTextures(state).length);
        }else{
            time = MathHelper.frameToSeconds(this.getTextures(state).length);
        }

        if(state == this.INTRO || state == this.TRAVEL ||  state == this.TRAVEL_GREEN) time /= 1.75;

        return time;
    }

    public static getTextures(state:string):Texture[]{
        if(state == this.INTRO || state == this.TRAVEL){
            if(state == this.TRAVEL){
                this.CART_LOOP = Math.random() > 0.5;
                state = this.CART_LOOP ? this.TRAVEL_GREEN : this.TRAVEL;
                return GameResources.getTextures(state);
            }
            return GameResources.getTextures(state);
        } 
        state = state.split("/")[0] + this.CART_MODE + "/" + state.split("/")[1];
        return GameResources.getTextures(state);
    }

    public static getIcons(trainValues:string[] = []):Texture[] & undefined[]{
        let textures:Texture[] & undefined[] = [];
        for(let i:number =0; i < trainValues.length; i++) 
            if(this.iconLinks.has(trainValues[i]))
            if(trainValues[i] == "X1")
                textures.push(undefined);
            else
                textures.push(GameResources.getTextures(this.iconLinks.get(trainValues[i])!)[0]);
        this.setCartMode(textures);
        return textures;
    }
}

export class XWaysCounter extends BaseView {

    protected value:number = 243;
    protected waysText:string = "Ways";

    protected freeSpins:number = 0;

    protected _logo:Sprite;
    protected _textCounter:Text;
    protected _textPost:Text;
    protected _headerBg:Sprite;
    protected _spineLoop:PIXI.spine.Spine;

    protected _itemsToHide:PIXI.DisplayObject[] = [];

    protected _trainShowItems:Sprite[] = [];
    protected _trainItemGlow:Sequence[] = [];
    protected _animationGlowTL:TimelineMax[] = [];

    protected _timeLine:TimelineMax;
    protected _textTimeline:TimelineMax;
    protected _animationLoop:TimelineMax | null;

    protected _glowTimeline:TimelineMax;

    protected _xwayState:XWayStateLevel = new XWayStateLevel(XWayStateLevel.LEVEL_1);
    protected HEADER_TEXTURE_PATH:string = "Header/";

    protected trainVisible:boolean = false;

    protected attentionSeq:Sequence;
    protected _trainSequence:Sequence;
    //Header
    protected _countsUp:boolean = true;

    protected CounterDim:IDimConfig = {
        dimOrientation : {
            landscape :{
                scale:      new Point( 1, 1),
                position:   new Point( 360, 105),
                // position:   new Point( 800, 2),
                layout :{
                    left:   new Point( 360, 105),
                    right:  new Point( 360, 105)
                }
            },
            portrait :{
                scale:      new Point( 1, 1),
                position:   new Point( 360, 105)
            }
        },
        WIDTH: 900,
        HEIGHT: 540,
    };

    private readonly DEFAULT_TEXT_STYLE:TextStyleOptions = {
        fontFamily : "Helvetica",
        fontStyle : FontStyle.ITALIC,
        fontSize : 42,
        fontWeight : FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 10,
        fill: "#ffe8d9",
    };

    public get headerTexture():Texture{
        return GameResources.getTextures(this.HEADER_TEXTURE_PATH + this._xwayState.TextureLvl)[0];
    }

    constructor() {
        super();
        StageManager.getLayer(PunkGameConfig.instance.LAYERS.FEATURE.name).addChild(this);
    }

    protected initAnimations():void{
        const _this = this;

        this.waysText = " " + Translation.translate(TranslationConfig.BANNER_WAYS);

        this._headerBg = this.createHeaderObject();
        this._spineLoop = new PIXI.spine.Spine(GameResources.getSpineAsset("Header"));
        this._spineLoop.visible = false;
        this.addChild(this._spineLoop);
        this._itemsToHide.push(this._spineLoop);

        this._textCounter = this.createTextObject();
        this.updateValue();
      
        this._logo = new Sprite(GameResources.getTextures("Header_Icon_Ena")[0]);
        this._logo.anchor.set(0.5,0.5)
        this._logo.position.set(PunkEngineManager.getReelPos(2).x,0);
        this.addChild(this._logo);
        this._itemsToHide.push(this._logo);

        this._trainSequence = new Sequence({textures:[]})
        this._trainSequence.anchor.set(0.5,0.5);
        this.addChild(this._trainSequence);

        this._trainShowItems = createTrainItems();
        this._trainItemGlow = createTrainItems("Train_Attention_Sector");
        this._trainItemGlow.forEach(sp => {sp.blendMode = BLEND_MODES.ADD});

        this.attentionSeq = Sequence.createSequence(GameResources.getTextures("Attention_sector"));
        this.attentionSeq.blendMode = BLEND_MODES.ADD;
        this.addChild(this.attentionSeq);

        this._textPost = this.createTextObject();
        this._textPost.text = ""
        this._textPost.alpha = 0;
        this._textPost.updateTransform();

        function createTrainItems(path:string = ""):Sequence[]{
            let offsetX = -(PunkSymbolData.DEFAULT_SYMBOL.DIM.WIDTH+PunkGameConfig.instance.REEL_ENGINE_CONFIG.DIM.PADDING_X) * 2.5;
            let temp:Sequence[] = [];
            for(let reel:number = 0; reel < PunkEngineManager.AllReels.length;reel++){
                const seq:Sequence = new Sequence({textures:GameResources.getTextures(path)})
                seq.alpha = 0;
                seq.position.set(offsetX,0)
                seq.anchor.set(0.5,0.5);
                _this.addChild(seq);
                temp.push(seq);
                offsetX += PunkSymbolData.DEFAULT_SYMBOL.DIM.WIDTH + PunkGameConfig.instance.REEL_ENGINE_CONFIG.DIM.PADDING_X;
            }
            return temp;
        }
    }

    public playAttention(indx:number,duration?:number):TimelineMax{
        this.attentionSeq.position = this._trainItemGlow[indx].position;
        return this.attentionSeq.playAnimation({onCompleteCallback:() => this.attentionSeq.alpha = 0, onStart:() => this.attentionSeq.alpha = 1,   duration:duration});
    }

    public playLoop():void{
        this._spineLoop.visible = true;
        this._spineLoop.state.setAnimation(0, this._xwayState.SpineLvl, true);
        TweenLite.fromTo(this._spineLoop,0.25,{alpha:0},{alpha:1})
    }

    public stopLoop():void{
        this._spineLoop.state.setEmptyAnimation(0,0);
        this._spineLoop.visible = false;
        TweenLite.fromTo(this._spineLoop,0.25,{alpha:1},{alpha:0})
    }

    protected createHeaderObject():Sprite{
        const headerObj = new Sprite(this.headerTexture);
        this.addChild(headerObj);
        headerObj.pivot.set(this.width*0.5,this.height*0.5);
        return headerObj;
    }

    protected createTextObject():Text{
        const textObj = new Text(this.value.toString());
        textObj.style = this.DEFAULT_TEXT_STYLE;
        textObj.text += this.waysText;
        textObj.anchor.set(0.5,0.5);
        this.addChild(textObj);
        this._itemsToHide.push(textObj);

        return textObj;
    }

    public totalWinMorse(duration:number,fadein:boolean = true):void{
        const tl = new TimelineMax();
        this._textPost.text = "....  .  .-..  .-..  ---  .--  ---  .-.  .-..  -..";
        this._textPost.updateTransform();
        this._textPost.anchor.set(0.5,0.5);

        if(fadein){
            tl.add([
                TweenLite.fromTo(this._textPost,duration,{alpha:0},{alpha:1,ease:Power3.easeInOut}),
                TweenLite.fromTo(this._textPost.scale,duration,{x:0.5},{x:0.75,y:0.75}),
                TweenLite.fromTo(this._textCounter,duration,{alpha:1},{alpha:0,ease:Power3.easeInOut}),
            ],0);
        }else{
            tl.add([
                TweenLite.to(this._textPost,duration,{alpha:0,ease:Power3.easeInOut}),
                TweenLite.to(this._textPost.scale,duration,{x:0.45,y:0.45,ease:Power3.easeInOut}),
                TweenLite.to(this._textCounter,duration,{alpha:1,ease:Power3.easeInOut})
            ],0);
        }
        tl.play();
    }

    public showCrazyMessage(message:string,duration:number):void{
        this._textTimeline = Helper.timeLineKiller(this._textTimeline,new TimelineMax());
        this._textPost.text = message;
        this._textPost.updateTransform();
        this._textPost.anchor.set(0.5,0.5);

        this.playLoop();

        this._textTimeline.add([
            TweenLite.fromTo(this._textPost,duration*0.25,{alpha:0},{alpha:1,ease:Power3.easeInOut}),
            TweenLite.fromTo(this._textPost.scale,duration*0.25,{x:0.5},{x:1.2,y:1.2}),
            TweenLite.fromTo(this._textCounter,duration*0.2,{alpha:1},{alpha:0,ease:Power3.easeInOut}),
        ]);

        this._textTimeline.add(() => AnimationEffects.Shake({
            obj: this._textPost,
            duration: duration,
            Intensity: 4,
            hertz: 130,
            x: 0.6,
            y: 0.7,
            ease:Power3.easeOut
        }),0)
  
        this._textTimeline.add([
            TweenLite.to(this._textPost,duration*0.25,{alpha:0,ease:Power3.easeInOut}),
            TweenLite.to(this._textPost.scale,duration*0.25,{x:0.7,y:0.7,ease:Power3.easeInOut}),
            TweenLite.to(this._textCounter,duration*0.25,{alpha:1,ease:Power3.easeInOut})
        ],duration*0.75);
        this._textTimeline.play();
    }

    public hardSetValue(value:number):void{
        this.value = value;
        this.updateValue();
        this.stopLoop();
    }

    public setValue(from:number | undefined, to:number, duration:number):TimelineMax {
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax());
        if(!this._textCounter.visible) return this._timeLine;
        if(this.value == to) return new TimelineMax();
        let fromValue = from != undefined ? from : this.value;

        this._countsUp = to > fromValue;
        
        this._timeLine = new TimelineMax({ onUpdate:() => { this.updateValue();}, onComplete:() => this.updateValue()} );
        this._timeLine.fromTo(this,duration,{value:fromValue},{value:to});
        return this._timeLine;
    }

    public setTrainItems(trainValues:string[] = []):void{
        const textures:Texture[] =  TrainState.getIcons(trainValues);
        for(let i:number = 0; i < this._trainShowItems.length;i++){
            (this._trainShowItems[i] as Sprite).texture = textures[i];
        }
    }

    public showGlowPositions(pos:number[],active:boolean, duration:number = 0.2):TimelineMax[]{
        const tlArr:TimelineMax[] = []
        for(let p:number = 0; p < pos.length; p++){
            const seq:Sequence = this._trainItemGlow[pos[p]];
            seq.reset(false, new TimelineMax());
            if(active) seq.timeline!.fromTo(seq, duration, {alpha: active ? 0 : 1}, {alpha: active ? 1 : 0},0);
            else {
                const fromA:number = seq.alpha;
                seq.timeline!.fromTo(seq, duration, {alpha: fromA}, {alpha: 0 },0);
            }
            tlArr.push(seq.timeline!);
        }
        return tlArr;
    }

    public setVisible(visible:boolean, duration:number = 0.3 ):TimelineMax{
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax())

        if(!visible) {
            this._trainSequence.setTexture(TrainState.getTextures(TrainState.INTRO))
            this._trainSequence.setFrame(0);
        }else{
            this._textPost.text = "";
        }

        this._timeLine.fromTo(this._trainSequence,duration,{alpha:visible ? 1 : 0}, { alpha:visible ? 0 : 1}, 0)

        for(let i:number = 0; i < this._itemsToHide.length;i++){
            this._timeLine.to(this._itemsToHide[i], duration,{ alpha: visible ? 1 : 0 }, 0);
        }
        return this._timeLine;
    }

    public getTrainItem(pos:number):Sprite{
        return this._trainShowItems[pos];
    }

    public showTrainItems(value:boolean,hidePos:number[],duration:number = 0.3):TimelineMax{
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax())

        for(let i:number = 0; i < this._trainShowItems.length;i++){
            if(value){
                const fromA:number = hidePos.indexOf(i) >= 0 ? (value ? 0 : 1) : (value ? 0 : 0.6);
                const fromT:number = hidePos.indexOf(i) >= 0 ? (value ? 1 : 0) : (value ? 0.6 : 0);
                this._timeLine.fromTo(this._trainShowItems[i], duration, {alpha: fromA}, { alpha: fromT}, 0);
            }else{
                const fromA:number = this._trainShowItems[i].alpha;
                const fromT:number = 0;
                this._timeLine.fromTo(this._trainShowItems[i], duration, {alpha: fromA}, { alpha: fromT}, 0);
            }
        }
        return this._timeLine;
    }

    public trainLoop(active:boolean):void{
        this._animationLoop = Helper.timeLineNuller(this._animationLoop);
        if(active){
            this._trainSequence.setTexture(TrainState.getTextures(TrainState.TRAVEL));
            this._animationLoop = new TimelineMax({ onComplete:() =>  this.trainLoop(true),
                // onRepeat:() => {
                //     this._trainSequence.setTexture(TrainState.getTextures(TrainState.TRAVEL));
                //     this._animationLoop?.totalDuration(TrainState.getDuration(TrainState.TRAVEL))
                // },
                // repeat:-1,
                // repeatDelay:0
            });
            this._animationLoop.add(this._trainSequence.playAnimation());
            this._animationLoop.timeScale(1.75);
        }
    }

    public timeLeftInLoop():number{
        if(this._animationLoop) return (this._animationLoop.duration() - this._animationLoop.time())/this._animationLoop.timeScale();
        return 0;
    }

    public counterActive(value:boolean):void{
        this._textCounter.visible = value;
        this._headerBg.visible = value;
        this._spineLoop.visible = value;
    }

    public trainActive():boolean{
        return this.trainVisible;
    }

    public trainState(state:string,reverse?:boolean):TimelineMax{
        this._trainSequence.setTexture(TrainState.getTextures(state));
        this._trainSequence.timeScale = 1;
        let clipName:string | undefined = undefined;
        let startFrame:number = 0;
        if(state == TrainState.INTRO){
            this._trainSequence.timeScale = 1.75;
            this.trainVisible = true;
            SoundManager.playSoundEffect(SoundConfig.instance.TRAIN_MOVES,1000000);
            SoundManager.onFadeSoundEffect(SoundConfig.instance.TRAIN_MOVES, 1, MathHelper.frameToSeconds(10));
        } 
        else if(state == TrainState.OPEN_CLOSE){
            if(!reverse){

                let delay:number = MathHelper.frameToSeconds(36);
                if(TrainState.CART_MODE == "")  delay = MathHelper.frameToSeconds(26);
                TweenLite.to(this,delay,{}).eventCallback("onComplete",() => {
                    SoundManager.stopSoundEffect(SoundConfig.instance.TRAIN_MOVES);
                    SoundManager.fadeAmbienceLoop(0.7,1400);
                    SoundManager.playSoundEffect(SoundConfig.instance.TRAIN_OPEN_CLOSE);
                });
            }else{
                clipName = "close";
                const fromFrame:number = TrainState.CART_MODE == "" ? 30 : 40;
                const toFrame:number = TrainState.CART_MODE == "" ? 20 : 30;
                startFrame = fromFrame;

                this._trainSequence.setClips([{name:"close", from: fromFrame ,to: toFrame}])
                SoundManager.fadeAmbienceLoop(1,2200);
                SoundManager.playSoundEffect(SoundConfig.instance.TRAIN_OPEN_CLOSE)
                TweenLite.to(this,MathHelper.frameToSeconds(12),{}).eventCallback("onComplete",() =>  {
                    SoundManager.playSoundEffect(SoundConfig.instance.TRAIN_MOVES,1000000);
                    SoundManager.onFadeSoundEffect(SoundConfig.instance.TRAIN_MOVES, 1, MathHelper.frameToSeconds(10));
                });
            }
        } 
        else if(state == TrainState.OUTRO){
            this.trainVisible = false;
            SoundManager.onFadeSoundEffect(SoundConfig.instance.TRAIN_MOVES,0,MathHelper.frameToSeconds(10))
            TweenLite.to(this,MathHelper.frameToSeconds(10),{}).eventCallback("onComplete",() =>  SoundManager.stopSoundEffect(SoundConfig.instance.TRAIN_MOVES));
        }

        this._trainSequence.setFrame(startFrame);
        return this._trainSequence.playAnimation({clip:clipName});
    }

    public UpdateFreeSpinCounter(value:number):void{
        this.freeSpins = value;
    }

    public FreeSpinsCounter(duration:number, fadein:boolean):void{
        const tl = new TimelineMax();
        if(fadein){
            this._textPost.text = this.freeSpins.toString() + " " +  Translation.translate(this.freeSpins <= 1 ? TranslationConfig.COUNTER_FS_ONE : TranslationConfig.COUNTER_FS_MANY);
            this._textPost.updateTransform();
            this._textPost.anchor.set(0.5,0.5);
            this._textPost.scale.set(0.75,0.75);
            // SlotGame.keypad.setZeroBetSpinCounter(this.freeSpins)
            tl.add([
                TweenLite.fromTo(this._textPost,duration,{alpha:0},{alpha:0.5,ease:Power3.easeInOut}),
                // TweenLite.fromTo(this._textPost.scale,duration,{x:0.5},{x:1,y:1}),
            ]);
            // tl.add([
            //     () => {this._textPost.text = (this.freeSpins-1).toString() +  " FreeSpins Left."},
            //     () => SlotGame.keypad.setZeroBetSpinCounter(this.freeSpins-1),
            //     TweenLite.fromTo(this._textPost.scale,duration*0.2,{x:0.9,y:0.9},{x:1,y:1})
            // ], duration*0.8)
        }else{
            tl.add([ 
                TweenLite.to(this._textPost,duration,{alpha:0,ease:Power3.easeInOut}),
                // TweenLite.to(this._textPost.scale,duration,{x:0.45,y:0.45,ease:Power3.easeInOut}),
            ],0);
        }
        tl.play();
    }

    public onResize():void{
        this.position = new Point( 360, ResizeHelper.IsLandscape() ? 105 : 65);
    }

    protected updateValue():void{
        this._textCounter.text = this.value.toFixed(0);


        if(!this._textCounter.visible) return;

        if(this._countsUp){
            if(this.value > this._xwayState.valueLvl && this._xwayState.set(this._xwayState.state+1)){
                TweenLite.to(this._textCounter.scale,0.15,{x:1.2,y:1.2}).eventCallback("onComplete",() => TweenLite.to(this._textCounter.scale,0.15,{x:1,y:1}))
                this.playLoop();
            }
        }else{
            if(this.value < this._xwayState.lastLvl && this._xwayState.set(this._xwayState.state-1)){
                TweenLite.to(this._textCounter.scale,0.1,{x:0.95,y:0.95}).eventCallback("onComplete",() => TweenLite.to(this._textCounter.scale,0.1,{x:1,y:1}))
                if(this._xwayState.equal(XWayStateLevel.LEVEL_1)){
                    this.stopLoop();
                }else
                    this.playLoop();
            }
        }

        this._headerBg.texture = this.headerTexture;
        this._textCounter.text += this.waysText;
        this._textCounter.updateTransform();
        this._textCounter.anchor.set(0.5,0.5);

        if(this._textCounter.width > 500) this._textCounter.style.fontSize = 34;
    }
}